import * as React from "react";
const SvgChevronLeftDouble = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 14.75-5-5 5-5m-7 10-5-5 5-5"
    />
  </svg>
);
export default SvgChevronLeftDouble;
